import React, { useEffect, useRef, useState } from "react"
import AnnouncementMenu from "./AnnouncementMenu"
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react"
import clsx from "clsx"

const AnnouncementHeader = () => {
	const [animationKey, setAnimationKey] = useState(0)
	const [announcements, setAnnouncements] = useState([])
	const [currentAnnouncement, setCurrentAnnouncement] = useState(0)
	const [touchActive, setTouchActive] = useState(false)
	let intervalId = useRef(null)

	const globalAnnouncements = [
		// {
		// 	mobile: `<a href='/collections/cleaner-coasts-2025/'>10% off with code MAKEWAVES for Cleaner Coasts 🌊</a>`,
		// 	tablet: `<a href='/collections/cleaner-coasts-2025/'>10% off with code MAKEWAVES for our Cleaner Coasts Collection 🌊</a>`, 
		// 	desktop: `<a href='/collections/cleaner-coasts-2025/'>10% off with code MAKEWAVES for our Cleaner Coasts Collection 🌊</a>`,
		// },
        
        {
			mobile: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`,
			tablet: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`, 
			desktop: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`,
		},

		{
			mobile: `<a href='/collections/bratz/'>Bratz Summer Freebies On Us →</a>`,
			tablet: `<a href='/collections/bratz/'>Bratz Summer 🎀 FREE limited-edition gifts on us! Shop now →</a>`, 
			desktop: `<a href='/collections/bratz/'>Bratz Summer 🎀 FREE limited-edition gifts on us! Shop now →</a>`,
		},
		//{
		//	mobile: `<a href='/collections/the-club-voyages-collection/'>Freebie for Club Voyages orders! 🐬</a>`,
		//	tablet: `<a href='/collections/the-club-voyages-collection/'>Free summer keepsake for Club Voyages orders 🌞</a>`, 
		//	desktop: `<a href='/collections/the-club-voyages-collection/'>Free summer keepsake for Club Voyages orders 🌞</a>`,
		//},
		{
			mobile: `<a href='/collections/all/'>FREE shipping on $100+ orders</a>`, 
			tablet: `<a href='/collections/all/'>FREE shipping on $100+ orders/a>`,
			desktop: `<a href='/collections/all/'>FREE shipping on orders $100 and above</a>`,
		},
	]

	const phAnnouncements = [
		// {
		// 	mobile: `<a href='/collections/cleaner-coasts-2025/'>10% off for Cleaner Coasts Collection 🌊</a>`,
		// 	tablet: `<a href='/collections/cleaner-coasts-2025/'>10% off + freebies for our Cleaner Coasts Collection 🌊</a>`, 
		// 	desktop: `<a href='/collections/cleaner-coasts-2025/'>10% off + freebies for our Cleaner Coasts Collection 🌊</a>`,
		// },
		//{
		//	mobile: `<a href='/collections/the-club-voyages-collection/'>Freebie for Club Voyages orders! 🐬</a>`,
		//	tablet: `<a href='/collections/the-club-voyages-collection/'>Free summer keepsake for Club Voyages orders 🌞</a>`, 
		//	desktop: `<a href='/collections/the-club-voyages-collection/'>Free summer keepsake for Club Voyages orders 🌞</a>`,
		//},
		//{
		//	mobile: `<a href='/collections/the-ashley-kelly-edit-sunchasers/'>Shop the edit: first 100 orders get a FREE luggage tag 🏄🏻‍♀️</a>`,
		//	tablet: `<a href='/collections/the-ashley-kelly-edit-sunchasers/'>Shop the edit: first 100 orders get a FREE luggage tag 🏄🏻‍♀️</a>`,
		//	desktop: `<a href='/collections/the-ashley-kelly-edit-sunchasers/'>Adventure called - your luggage needs ID. FREE luggage tag for the first 100 orders 🏄🏻‍♀️</a>`,
		//},
        {
			mobile: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`,
			tablet: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`, 
			desktop: `<a href='/collections/the-bridal-edit/'>Say yes and get up to 15% off The Bridal Edit 💍</a>`,
		},
        
		{
			mobile: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
			tablet: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
			desktop: `<a href='/collections/all/'>FREE SHIPPING NATIONWIDE. Shop now!</a>`,
		},

	]

	useEffect(() => {
		//mock api call
		setAnnouncements(
			process.env.GATSBY_STORE !== "PH" ? globalAnnouncements : phAnnouncements
		)
	}, [])

	useEffect(() => {
		if (announcements.length > 0) startInterval()

		return () => {
			stopInterval() // Cleanup on unmount
		}
	}, [announcements.length])

	useEffect(() => {
		if (touchActive) stopInterval()
		else startInterval()
	}, [touchActive])

	const startInterval = () => {
		if (intervalId.current) clearInterval(intervalId.current)

		intervalId.current = setInterval(() => {
			setCurrentAnnouncement((prev) => (prev + 1) % announcements.length)
		}, 11000)
	}

	const stopInterval = () => {
		if (intervalId.current) clearInterval(intervalId.current)
	}

	const handleNextAnnouncement = (val) => {
		const announcementIndex =
			currentAnnouncement === 0 && val === -1
				? announcements.length - 1
				: currentAnnouncement === announcements.length - 1 && val === 1
				? 0
				: currentAnnouncement + val

		clearInterval(intervalId)
		setAnimationKey((prev) => prev + 1)
		setCurrentAnnouncement(announcementIndex)
		startInterval()
	}

	return (
		<React.Fragment>
			<div className="relative flex gap-x-6 bg-primary px-6 py-2.5 sm:px-3.5 h-10 text-white text-sm z-[51]">
				<div
					className={`relative flex justify-between items-center max-w-[1440px] mx-auto flex-1 md:gap-x-4`}
				>
					{announcements.length > 0 && (
						<>
							{/* <div
                className={`block lg:hidden before:content-[''] before:absolute before:inset-0 before:bg-marquee-gradient overflow-hidden w-[92vw] md:w-[460px] lg:w-[570px] xl:w-[920px] absolute h-full z-10 pointer-events-none -ml-1 md:ml-6`}
              /> */}
							{/* <div className="absolute flex flex-nowrap justify-between w-[90vw] md:w-[456px] lg:w-[600px] xl:w-[850px] -ml-1 md:ml-3 z-20 pointer-events-none"> */}
							<div className="absolute left-0 flex flex-nowrap justify-between w-full md:w-[482px] lg:w-[600px] xl:w-[850px] px-4 md:px-0 md:ml-3 z-20 pointer-events-none">
								<CaretLeftIcon
									className={`cursor-pointer self-start pointer-events-auto`}
									size={16}
									onClick={() => handleNextAnnouncement(-1)}
								/>
								<CaretRightIcon
									className={`cursor-pointer self-end pointer-events-auto`}
									size={16}
									onClick={() => handleNextAnnouncement(1)}
								/>
							</div>
							{/* <div className={`relative flex overflow-hidden w-full md:w-[420px] lg:w-[550px] xl:w-[800px] h-full ml-0 md:ml-8 z-0`}> */}
							<div
								className={`relative flex overflow-hidden w-full md:w-[482px] lg:w-[550px] xl:w-[800px] h-full z-0`}
							>
								<div
									key={animationKey}
									className="absolute lg:px-4 left-0 w-full flex items-center cursor-pointer"
									// onTouchStart={setTouchActive(!touchActive)}
								>
									<div
										className={clsx('inline-block text-center whitespace-nowrap animate-fade-in-out animate w-full announcement-container', touchActive ? "animation-paused" : "animation-running")}
										onMouseEnter={() => setTouchActive(true)}
										onMouseLeave={() => setTouchActive(false)}
									>
										<div
											className="block md:hidden"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.mobile,
											}}
										/>
										<div
											className="hidden md:block lg:hidden"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.tablet,
											}}
										/>
										<div
											className="hidden lg:block"
											dangerouslySetInnerHTML={{
												__html: announcements[currentAnnouncement]?.desktop,
											}}
										/>
									</div>
								</div>
							</div>
						</>
					)}
					<AnnouncementMenu />
				</div>
			</div>
		</React.Fragment>
	)
}

export default AnnouncementHeader
